module.exports = __webpack_public_path__ + "img/evalmatters-logo.3d9e0dbf.png";